import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class TimeOffRequestAcceptButton extends React.Component {
    render() {
        const { timeOffRequest, isAdmin, isApprover, onAcceptClick } =
            this.props;

        if (
            !timeOffRequest ||
            !isAdmin ||
            (!isApprover &&
                timeOffRequest.timesheetStatusId >=
                    TimesheetStatus.Validated) ||
            timeOffRequest.timesheetStatusId >= TimesheetStatus.Approved
        ) {
            return null;
        }

        const verbName = isApprover ? 'Approve' : 'Validate';

        return (
            <Button
                type="button"
                color="success"
                onClick={() => onAcceptClick()}
            >
                <FontAwesomeIcon icon={faThumbsUp} className="mr-1" />
                {verbName}
            </Button>
        );
    }
}
